import { render, staticRenderFns } from "./HiloTable.vue?vue&type=template&id=1a0b2a1a"
import script from "./HiloTable.vue?vue&type=script&lang=js"
export * from "./HiloTable.vue?vue&type=script&lang=js"
import style0 from "./HiloTable.vue?vue&type=style&index=0&id=1a0b2a1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports